import type { Role, Permission, PermissionGroup } from '../types';

export function getRoleDisplayName(role: Role, locale: string): string {
  if (locale === 'ar' && role.name_ar) return role.name_ar;
  if (locale === 'en' && role.name_en) return role.name_en;
  return role.name_en || role.name_ar || role.name;
}

export function toRole(raw: Record<string, unknown>): Role {
  return {
    id: raw.id as number,
    name: raw.name as string,
    name_en: (raw.name_en as string) ?? null,
    name_ar: (raw.name_ar as string) ?? null,
    color: (raw.color as string) ?? '#64748b',
    guard_name: (raw.guard_name as string) ?? 'web',
    permissions: Array.isArray(raw.permissions)
      ? raw.permissions.map((p: unknown) =>
          typeof p === 'string' ? p : (p as Permission).name
        )
      : [],
    users_count: (raw.users_count as number) ?? 0,
    can_edit: (raw.can_edit as boolean) ?? true,
    can_delete: (raw.can_delete as boolean) ?? false,
    created_at: raw.created_at as string,
    updated_at: raw.updated_at as string
  };
}

export function toRoleList(raw: Record<string, unknown>[]): Role[] {
  return raw.map(toRole);
}

export function groupPermissions(permissions: Permission[]): PermissionGroup[] {
  const grouped = new Map<string, Permission[]>();

  for (const permission of permissions) {
    const group = permission.name.split('.')[0] ?? 'other';
    const existing = grouped.get(group) ?? [];
    existing.push(permission);
    grouped.set(group, existing);
  }

  return Array.from(grouped.entries())
    .map(([group, perms]) => ({ group, permissions: perms }))
    .sort((a, b) => a.group.localeCompare(b.group));
}
